export enum Navlystype {
    UdefinertNavlystype = 0,
    Retningslys = 1,
    Lanterne = 2,
    Overettlys = 4,
    LuftfartsfyrLykt = 5,
    Lufthindringslys = 6,
    FlombelysningIndirekteBelysning = 8,
    Lysband = 9,
    Bifyr = 10,
    LysIHorizontalGruppe = 19,
    LysIVertikalGruppe = 20,
    NavigasjonslysGenerelt = 99,
}

export enum Eier {
    Udefinert = 0,
    Avinor = 1,
    Forsvaret = 2,
    Havnevesenet = 3,
    Kystverket = 4,
    Privat = 5,
    Vegvesenet = 6,
    Kommune = 7,
}

export enum Kystverksdistrikt {
    Udefinert = 0,
    KystverketSorost = 1,
    KystverketVest = 2,
    KystverketMidtNorge = 3,
    KystverketNordland = 4,
    KystverketTromsOgFinmark = 5,
    KystverketSvalbard = 6,
    Kontinentalsokkel = 7,
}

export enum Merkedefinisjon {
    Udefinert = 0,
    IsolertFareboye = 1,
    Spesialboye = 2,
    Senterledboye = 3,
    Installasjonsboye = 4,
    IsolertFareFastmerke = 5,
    SpesialFastmerke = 6,
    SenterledFastmerke = 7,
    AndreFastmerker = 8,
    Nordkardinalboye = 9,
    Sorkardinalboye = 10,
    Ostkardinalboye = 11,
    Vestkardinalboye = 12,
    StyrbordLateralboye = 13,
    BabordLateralboye = 14,
    StyrbordLateralmerke = 15,
    BabordLateralmerke = 16,
    Lyktefundament = 17,
}

export enum Sksdstatus {
    Udefinert = 0,
    Underkjent = 1,
    Godkjent = 2,
    Sendt = 3,
    Ubehandlet = 4,
}

export enum Tilstand {
    Udefinert = 0,
    God = 1,
    Middels = 2,
    Darlig = 3,
    Havarert = 4,
}

export enum Nautiskfunksjon {
    Udefinert = 0,
    God = 1,
    Brukbar = 2,
    Darlig = 3,
}

export enum Beskrivelse {
    Udefinert = 0,
    HIBPaStang = 1,
    HIBPaStativ = 2,
    HIBPaSoyle = 3,
    HIBPaVarde = 4,
    IBPaBro = 5,
    IBPaStang = 6,
    IBPaStativ = 7,
    IBPaSoyle = 8,
    IBPaVarde = 9,
    LanterneKaimarkering = 10,
    LanternePaBro = 11,
    LanternePaStang = 12,
    LanternePaStangMedIB = 13,
    LanternePaStativ = 14,
    LanternePaStativMedIB = 15,
    LanternePaSoyle = 16,
    LanternePaSoyleMedIB = 17,
    LanternePaVarde = 18,
    LanternePaVardeMedIB = 19,
    Lyktehus = 20,
    LyktehusMedIB = 21,
    LyktehusPaStativ = 22,
    LyktehusPaStativMedIB = 23,
    LyktehusPaSoyle = 24,
    LyktehusPaSoyleMedIB = 25,
    LyktehusPaUnderbygning = 26,
    LyktehusPaUnderbMedIB = 27,
    LyktehusPaVarde = 28,
    LyktehusPaVardeMedIB = 29,
    FyrbygningMedTarn = 30,
    HvittTarnMedBelte = 31,
    RodtTarnMed1HvittBelte = 32,
    RodtTarnMed2HviteBelte = 33,
    Lysboye = 34,
    Aerolys = 35,
}

export enum Kategori {
    Udefinert = 0,
    AvgjorendeForSikkerNavigasjon = 1,
    ViktigForSikkerNavigasjon = 2,
    MindreViktigForSikkerNavigasjon = 3,
    OverfledigForSikkerNavigasjon = 4,
}

export enum Lysgjennomgang {
    Ingen = 0,
    Plast = 1,
    Glass = 2,
}

export enum SeamarkColors {
    Undefined = 0,
    White = 1,
    Black = 2,
    Red = 3,
    Green = 4,
    Blue = 5,
    Yellow = 6,
    Gray = 7,
    Brown = 8,
    Gold = 9,
    Purple = 10,
    Orange = 11,
    Magenta = 12,
    Pink = 13,
}

export enum Sjostatus {
    Udefinert = 0,
    Permanent = 1,
    SlukketSlettet = 11,
}

export enum Fundamenttype {
    Ukjent = 0,
    Pillar = 1,
    Landemerke = 2,
    Bygningspunkt = 3,
}

export enum Pillarkategori {
    Udefinert = 0,
    RektangulaerStang = 1,
    Lyktehus = 2,
    PaelePillarStolpe = 3,
    Stativ = 4,
}

export enum Funksjon {
    UkjentFunksjon = 0,
    StotteForEtLys = 33,
}

export enum Landemerkekategori {
    Udefinert = 0,
    Varde = 1,
    Mast = 7,
    ColumnPillar = 10,
    Statue = 13,
    Taarn = 17,
    Vindmolle = 18,
    Vindmotor = 19,
}

export enum Visuelltydelighet {
    Udefinert = 0,
    TydeligVisuelt = 1,
    IkkeTydeligVisuelt = 2,
}

export enum Underbyggtype {
    Udefinert = 0,
    TreBeningStativ = 1,
    FireBeningStativ = 2,
    FemBeningStativ = 3,
    Betong = 4,
    Betongsoeyle = 5,
    Betongsoeyler = 6,
    Baake = 7,
    Casingroer = 8,
    Drillpiperoer = 9,
    Emneroer = 10,
    FagverkStaal = 11,
    FagverkTre = 12,
    Husvegg = 13,
    Ingen = 14,
    Jernstang = 15,
    Komposittstang = 16,
    Plastsoeyler = 17,
    Stein = 18,
    SteinTaarn = 19,
    Staalsoeyler = 20,
    Stoepejernstaarn = 21,
    Stoepejernsoeyle = 22,
    SyrefastStang = 23,
    Teglsteinstaarn = 24,
    Tre = 25,
    Trestolpe = 26,
    Varde = 27,
    TripodBetong = 28,
}

export enum JaNei {
    Nei = 0,
    Ja = 1,
}

export enum Merkeform {
    Udefinert = 0,
    StangPaale = 1,
    Baake = 4,
    Varde = 6,
    Annet = 7,
}

export enum Spesialmerketypefast {
    Udefinert = 0,
    ODASStorOceanografiskBoeyeForDatainnsamling = 9,
    Fortoeyningsmerke = 14,
    Overettmerke = 16,
    FoulGroundMarkYachting = 45,
    HeliportMerke = 47,
    MerkeMedUkjentFormaal = 52,
}

export enum Toppmerketype {
    Ingen = 0,
    Ballong = 1,
    HvitOgSortKrekse = 2,
    HvitKrekse = 3,
    Kjegle = 4,
    Kors = 5,
    Kryss = 6,
    Kule = 7,
    KuleMedKrekse = 8,
    KuleMedViser = 9,
    Radarreflektor = 10,
    SortKrekse = 11,
    Tonne = 12,
    Viser = 13,
}

export enum Merkemonster {
    Ingen = 0,
    VannretteBaand = 1,
    LoddretteStriper = 2,
    DiagonaleBaand = 3,
    Ruter = 4,
    StriperUkjentRetning = 5,
}

export enum Boyeform {
    Udefinert = 0,
    KoniskBoeye = 1,
    SylindriskBoeye = 2,
    Kuleboeye = 3,
    Boeyestake = 4,
    Stake = 5,
    Tonneboeye = 6,
    Superboeye = 7,
    Isboeye = 8,
}

export enum Merketypeflytende {
    Udefinert = 0,
    NordkardinalmerkeEllerBabordlateralmerke = 1,
    OstkardinalmerkeEllerStyrbordlateralmerke = 2,
    Sorkardinalmerke = 3,
    Vestkardinalmerke = 4,
    Spesialmerke = 52,
}

export enum Sjomerketype {
    Udefinert = 0,
    Spesialmerke = 1,
    FrittliggendeGrunneFare = 5,
    Senterled = 6,
    Nordkardinalmerke = 21,
    Ostkardinalmerke = 22,
    Sorkardinalmerke = 23,
    Vestkardinalmerke = 24,
    BabordLateralmerke = 31,
    StyrbordLateralmerke = 32,
}

export enum Frekvensband {
    Udefinert = 0,
    S = 1,
    X = 2,
    XPlusS = 3,
}

export enum Responsintervall {
    Udefinert = 0,
    FemtenTrettiS = 1,
    AttenTrettiS = 2,
    SeksTolvS = 3,
    SeksTrettiS = 4,
    SekstiS = 5,
}

export enum Radarfyrtype {
    UkjentRadarfyrtype = 0,
    Radarfyr = 1,
    RadarSvarfyr = 2,
    RadarSvarfyrMedAngittRetning = 3,
}

export enum Racontype {
    UkjentRaconType = 0,
    FAFrequencyAgile = 1,
    ITOFAR = 2,
    SFSweptFrequency = 3,
}

export enum Raconmorsetegn {
    Udefinert = 0,
    MorsetegnB = 1,
    MorsetegnG = 2,
    MorsetegnK = 3,
    MorsetegnM = 4,
    MorsetegnN = 5,
    MorsetegnO = 6,
    MorsetegnT = 7,
}

export enum Raconklasse {
    Udefinert = 0,
    RARacon = 7,
}

export const fyrlistekarakterFastYellowLys = 8;
